import { Dispatcher } from './Dispatcher';
import { Actions } from './Actions';
import { Store } from './Store';

export const dispatcher = Dispatcher.get();
export const actions = Actions.get(dispatcher);
export const store = Store.get({}, dispatcher, actions);
